import { LocalizationProvider as MUILocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

type LocalizationProviderProps = {
  children: React.ReactNode;
};

export const LocalizationProvider: React.FC<LocalizationProviderProps> = ({ children }) => {
  return (
    <MUILocalizationProvider adapterLocale="en-gb" dateAdapter={AdapterDayjs}>
      {children}
    </MUILocalizationProvider>
  );
};
